import React from "react";
import { UserX } from "lucide-react";
import PropTypes from "prop-types";

import { UIEmptyState } from "../../../../components/ui";

const ApplicantsEmptyState = ({ title, description }) => (
  <UIEmptyState
    classNames={{
      root: "applicants-page-container__empty",
      iconCircle: "applicants-page-container__empty-icon-circle",
    }}
    title={title}
    description={description}
    icon={<UserX size={40} aria-hidden />}
  />
);

ApplicantsEmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ApplicantsEmptyState;
